import React from "react"

const ViewOnIcon = () => {
    return (
        <div className="transition-transform duration-300 ease-in-out transform rotate-180 group-hover:rotate-0">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 16 12" fill="none">
                <path d="M14.3628 5.36333C14.5655 5.64755 14.6668 5.78965 14.6668 6.00001C14.6668 6.21037 14.5655 6.35247 14.3628 6.63669C13.4521 7.91372 11.1263 10.6667 8.00016 10.6667C4.87402 10.6667 2.54823 7.91372 1.63752 6.63669C1.43484 6.35247 1.3335 6.21037 1.3335 6.00001C1.3335 5.78965 1.43484 5.64755 1.63752 5.36333C2.54823 4.0863 4.87402 1.33334 8.00016 1.33334C11.1263 1.33334 13.4521 4.0863 14.3628 5.36333Z" stroke="#2D2D2D" stroke-width="1.5" />
                <path d="M10 6C10 4.89543 9.10457 4 8 4C6.89543 4 6 4.89543 6 6C6 7.10457 6.89543 8 8 8C9.10457 8 10 7.10457 10 6Z" stroke="#141B34" stroke-width="1.5" />
            </svg>
        </div>
    )
}
export default ViewOnIcon